import { Space, TextLoader } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const CatalogItemDetailsSkeleton = () => {
  const intl = useProcurifyIntl()

  return (
    <div
      role='status'
      aria-busy='true'
      aria-label={intl.formatMessage(messages.loadingAriaLabel)}
    >
      <Space direction='vertical' size='medium'>
        <TextLoader height={240} />
        <TextLoader width={120} height={20} />
        <Space direction='vertical' size='small'>
          <TextLoader height={20} />
          <TextLoader width='70%' height={20} />
        </Space>
        <TextLoader width={160} height={28} />
        <Space direction='vertical' size='small'>
          <TextLoader height={12} />
          <TextLoader height={12} />
          <TextLoader width='60%' height={12} />
        </Space>
      </Space>
    </div>
  )
}
